import React, { FC } from 'react';

import { getDayAndMonthFromDate } from '@/shared/lib/date';
import { useLocale } from '@/shared/hooks/useLocale';

import styles from './_Announce.module.css';

interface AnnounceProps {
    text?: string;
    footerText?: string;
    availabilityDate?: string;
}

export const Announce: FC<AnnounceProps> = ({ text, footerText, availabilityDate = '' }) => {
    const locale = useLocale();
    const { day, month } = getDayAndMonthFromDate(availabilityDate, locale.lang);

    return (
        <div className={styles.root}>
            {text ? (
                <span className={styles.text}>{text}</span>
            ) : (
                <>
                    {day && <span className={styles.day}>{day}</span>}
                    {month && <span className={styles.month}>{month}</span>}
                </>
            )}
            {footerText && <span className={styles.footerText}>{footerText}</span>}
        </div>
    );
};
